import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import sys from './modules/sys'
import tags from './modules/tagsView'
import app from './modules/app'
import settings from './modules/settings'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isMB: document.body.offsetWidth < 768
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    sys,
    tags,
    app,
    settings
  }
})

export default store;
